{
  "identifiers": {
    "customerNumber": "Kundenummer",
    "contractorNumber": "Entreprenørnummer",
    "buyerNumber": "Kjøpernummer",
    "organizationNumber": "Org.nummer",
    "fictionalOrganizationNumber": "Fikt. org.nummer"
  },
  "copyField": {
    "copy": "Kopier {{label}}",
    "copied": "{{label}} kopiert"
  }
}
